import React from "react";
import Styled from "./styled";

const FooterLogo: React.FC = () => {
    const templateStaticPath = (window as any).server ? JSON.parse((window as any).server).staticPath : "";
    return <Styled src={`${templateStaticPath}/static/img/logos/con-i-bambini.png`} />;
};

export default FooterLogo;
